<template>
  <v-container fluid class="d-flex align-center justify-center fill-height">
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12" sm="8" md="4">
        <v-card class="pa-5" elevation="3">
          <v-card-title class="text-center">{{ $t('message.changePassword') }}</v-card-title>
          <v-card-text>
            <v-form>
              <v-text-field
                :label="$t('message.oldPassword')"
                prepend-icon="mdi-lock"
                v-model="oldPassword"
                type="password"
                required
              ></v-text-field>

              <v-text-field
                :label="$t('message.newPassword')"
                prepend-icon="mdi-lock-check"
                v-model="newPassword"
                type="password"
                required
              ></v-text-field>

              <v-btn color="primary" class="mt-4" block @click="changePassword">
                {{ $t('message.changePassword') }}
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Snackbar for success message -->
    <v-snackbar
        v-model="snackbarSuccess"
        color="success"
        top
        multi-line
        timeout="3000"
    >
      {{ successMessage }}
      <v-btn color="white" text @click="snackbarSuccess = false">Close</v-btn>
    </v-snackbar>

    <!-- Snackbar for error message -->
    <v-snackbar
        v-model="snackbarError"
        color="error"
        top
        multi-line
        timeout="3000"
    >
      {{ errorMessage }}
      <v-btn color="white" text @click="snackbarError = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios';
import {mapActions} from 'vuex';

export default {
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      snackbarSuccess: false,
      snackbarError: false,
      successMessage: '', // Store success message
      errorMessage: '', // Store error message
    };
  },
  methods: {
    ...mapActions(['logout']),
    async changePassword() {
      try {
        const access_token = localStorage.getItem('access_token');
        // Assuming you have an API endpoint to handle password change
        await axios.post('/api/user/ChangePasswordView/', {
          old_password: this.oldPassword,
          new_password: this.newPassword,
          access_token: access_token
        });

        // Show success message
        this.successMessage = 'Password changed successfully!';
        this.snackbarSuccess = true;

        // Perform logout
        await this.$store.dispatch('logout'); // Update Vuex state
        localStorage.removeItem('access_token');

        // Redirect to login page after a short delay
        setTimeout(() => {
          this.$router.push('/login');
        }, 3000); // Delay to show success message

      } catch (error) {
        // Handle error
        console.error('Change password error:', error.response ? error.response.data : error.msg);
        this.errorMessage = error.response?.data?.msg || 'Failed to change password. Please try again.';
        this.snackbarError = true;
      }
    },
  },
};
</script>

<style scoped>
.fill-height {
  min-height: 100vh;
}
</style>